(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-projects-featured"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-tpl-floating]').forEach(section => {
    if (section.hasAttribute('data-float-ready')) return;
    section.setAttribute('data-float-ready', '');
    const button = section.querySelector('[data-tpl-motion-toggle]');
    if (!button) return;
    button.hidden = false;
    button.addEventListener('click', () => {
      const paused = !section.hasAttribute('data-float-paused');
      section.toggleAttribute('data-float-paused', paused);
      button.setAttribute('aria-pressed', String(paused));
      button.querySelector('[data-tpl-motion-state]').textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    });
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
